import { useEffect, useMemo, useState } from "react";

import directorApi from "@contexts/director/api";
import { useDirectorContext } from "@contexts/director";

const safeError = (error) => ({
  status: error?.status ?? 0,
  code: error?.code ?? "module1_failed",
  message: error?.message ?? "Não foi possível carregar esta leitura.",
  retryable: error?.retryable === true,
});

const useDirectorSurface = (surface, filters = {}, { api = directorApi } = {}) => {
  const { selectedCompanyId } = useDirectorContext();
  const signature = useMemo(() => JSON.stringify(filters), [filters]);
  const requestSignature = useMemo(
    () => JSON.stringify([surface, selectedCompanyId, signature]),
    [selectedCompanyId, signature, surface],
  );
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState({
    data: null,
    dataSignature: null,
    loading: false,
    error: null,
  });

  useEffect(() => {
    let active = true;
    if (!selectedCompanyId) {
      setState({ data: null, dataSignature: requestSignature, loading: false, error: null });
      return () => { active = false; };
    }
    setState({ data: null, dataSignature: requestSignature, loading: true, error: null });
    api.fetchDirectorModule1Surface(surface, selectedCompanyId, JSON.parse(signature))
      .then((data) => {
        if (active) setState({ data, dataSignature: requestSignature, loading: false, error: null });
      })
      .catch((error) => {
        if (active) setState({
          data: null,
          dataSignature: requestSignature,
          loading: false,
          error: safeError(error),
        });
      });
    return () => { active = false; };
  }, [api, selectedCompanyId, signature, surface, revision, requestSignature]);

  const current = state.dataSignature === requestSignature;

  return {
    data: current ? state.data : null,
    dataSignature: current ? state.dataSignature : null,
    error: current ? state.error : null,
    loading: current ? state.loading : Boolean(selectedCompanyId),
    requestSignature,
    reload: () => setRevision((value) => value + 1),
  };
};

export default useDirectorSurface;
